function n(e, i, r) {
  return !Number.isFinite(e) || !Number.isFinite(i) || !Number.isFinite(r) ? !1 : e >= i && e <= r;
}
export {
  n as isBetweenInclusive
};
